// MomentStrip — renders the emotional moments for a focused decision. Each badge shows
// ONLY when its real predicate returned present:true (gated by lib/moments in the
// caller). Reused by the Execution and Reflection regions. aria-live for the SR channel.
import React from "react";
import MomentBadge from "./MomentBadge";

export default function MomentStrip({ moments }) {
  const m = moments || {};
  const any = ["supersede", "confidence", "conflict", "knowledge"].some((k) => m[k] && m[k].present);
  if (!any) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="moments" aria-live="polite">
      {m.supersede && m.supersede.present ? (
        <MomentBadge kind="supersede" tone="info" title="Changed since first recorded" detail={`Superseded${m.supersede.at ? ` at ${m.supersede.at}` : ""} — the earlier version was replaced.`} source={m.supersede.source} />
      ) : null}
      {m.confidence && m.confidence.present ? (
        <MomentBadge
          kind={m.confidence.direction === "increased" ? "confidence_up" : "confidence_down"}
          tone={m.confidence.direction === "increased" ? "positive" : "caution"}
          title={`Confidence ${m.confidence.direction}`}
          detail={`${m.confidence.from} → ${m.confidence.to} across ${m.confidence.versions} versions.`}
          source={m.confidence.source}
        />
      ) : null}
      {m.conflict && m.conflict.present ? (
        <MomentBadge kind="conflict" tone="caution" title="Conflicting evidence detected" detail={`Cohort/producer-level: ${m.conflict.disagreements} disagreement(s) of ${m.conflict.pairs_compared} compared.`} source={m.conflict.source} />
      ) : null}
      {m.knowledge && m.knowledge.present ? (
        <MomentBadge kind="knowledge" tone="neutral" title="Relevant knowledge" detail={`${m.knowledge.matches.length} lesson(s) — matched by decision type + business unit.`} source={m.knowledge.source} />
      ) : null}
    </div>
  );
}
